import { Button, Icon } from '@fasstech/middle-design-system';

const DownloadButton = ({
  onClick,
  text,
  isLoading = false,
  icon,
  disabled = false,
  isDisplayed = true
}) => {
  if (!isDisplayed) return null;
  return (
    <div>
      <Button
        variant="secondary"
        onClick={onClick}
        loading={isLoading}
        disabled={disabled}
        data-testid={`downloadButton${icon}`}>
        <div className="flex gap-x-2 items-center">
          <Icon name={icon} />
          {text}
        </div>
      </Button>
    </div>
  );
};

export default DownloadButton;
